export const GET_PLC_POPUP_STATUS = "GET_PLC_POPUP_STATUS";
export const GET_PLC_POPUP_STATUS_SUCCESS = "GET_PLC_POPUP_STATUS_SUCCESS";
export const GET_PLC_POPUP_STATUS_ERROR = "GET_PLC_POPUP_STATUS_ERROR";
